import protoComponent from './proto'
export default {
  name: 'SlAmapFullscreen',
  extends: protoComponent,
  props:{
    value:{
      type:Boolean,
      default:false
    }
  },
  created(){
    this.$watch('value' , function(nv){
      if( nv != this.currentValue){
        this.currentValue = nv
        this.setFullscreen()
      }
    },{immediate:true})
  },
  data(){
    return {
      currentValue:false
    }
  },
  methods:{
    setFullscreen(v){
      this.$parent.setFullscreen(this.currentValue )
    },
    handleFs(){
      this.currentValue = !this.currentValue
      this.setFullscreen()
      this.$emit('input' , this.currentValue)
      this.$emit('change' , this.currentValue)
    }
  },
  render(){
    return (
      <div style="position: absolute;top: 5px;right: 5px;"><Icon custom="i-icon icon-fullscreen" size="20" on-click={this.handleFs} /></div>
    )
  }
}